import * as countries from 'i18n-iso-countries';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { TaxReportTableAustria } from 'src/components/issuer/tables/TaxReportTableAustria';
import { TaxReportTableGermany } from 'src/components/issuer/tables/TaxReportTableGermany';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { useSPV } from 'src/hooks/useSPV';
import { useSpvTaxInformation } from 'src/hooks/useSpvTaxInformation';
import { Routes } from 'src/router/Routes';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Card, CardContent, Typography } from '@mui/material';

export const IssuerTax = () => {
  const { t } = useTranslation();
  const { spvId } = useParams();
  const spv = useSPV(spvId);
  const taxReport = useSpvTaxInformation(spvId);
  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ISSUER.ROOT,
            label: t('issuer.overview.title'),
            icon: <PeopleAltIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
          {
            link: Routes.ISSUER.TAX,
            label: spv?.companyName || '',
          },
        ]}
        headline={spv?.companyName || ''}
      />
      <Card>
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 500, mb: 3 }}>
            {t('issuer.tax.title')}
          </Typography>
          {spv && spv.address.countryCode === countries.getAlpha3Code('Austria', 'en') && taxReport && (
            <TaxReportTableAustria spv={spv} taxReport={taxReport} />
          )}
          {spv && spv.address.countryCode === countries.getAlpha3Code('Germany', 'en') && taxReport && (
            <TaxReportTableGermany spv={spv} taxReport={taxReport as any} />
          )}
        </CardContent>
      </Card>
    </>
  );
};
